export default () => ({
  buttonMode: false,
  resizeMode: false,
  buttonHeight: 0,

  init() {
    // Set initial resize mode based on window width
    this.resizeMode = window.innerWidth < 1024;

    // Initial button position update
    this.updateButtonPosition();

    // Update button height
    this.updateButtonHeight();

    // Add event listeners
    window.addEventListener("scroll", () => this.updateStickyButton(), {
      passive: true,
    });
    window.addEventListener("resize", () => this.handleResize());
  },

  handleResize() {
    const newResizeMode = window.innerWidth < 1024;

    if (newResizeMode !== this.resizeMode) {
      this.resizeMode = newResizeMode;
      this.updateButtonPosition();
    }

    // Update height on resize
    this.updateButtonHeight();
  },

  updateButtonPosition() {
    const button = this.$el;
    const container = document.getElementById(
      `product-content-${this.sectionId}`
    );
    const upper = document.getElementById("upper-buttons");
    const lower = document.getElementById("lower-buttons");

    if (!container || !upper || !lower) return;

    if (this.resizeMode) {
      // Move button to lower section on mobile
      if (button.parentNode !== lower) {
        lower.appendChild(button);
      }
    } else {
      // Move button back to container above upper buttons on desktop
      if (button.parentNode !== container) {
        container.insertBefore(button, upper);
      }
    }
  },

  updateStickyButton() {
    const button = this.$el;
    const lower = document.getElementById("lower-buttons");

    if (!lower) return;

    const lowerRect = lower.getBoundingClientRect();
    const shouldBeRelative =
      lowerRect.top + button.offsetHeight < window.innerHeight;

    if (shouldBeRelative && !this.buttonMode) {
      // Switch to relative positioning
      button.classList.add("relative", "!px-0");
      button.classList.remove("fixed");
      this.buttonMode = true;
    } else if (!shouldBeRelative && this.buttonMode) {
      // Switch to fixed positioning
      button.classList.add("fixed");
      button.classList.remove("relative", "!px-0");
      this.buttonMode = false;
    }
  },

  updateButtonHeight() {
    this.$nextTick(() => {
      this.buttonHeight = this.$el.offsetHeight;

      // Update CSS variable
      document.documentElement.style.setProperty(
        "--pdp-buy-button-height",
        `${this.buttonHeight}px`
      );
    });
  },

  // Cleanup function for Alpine.js
  destroy() {
    // Alpine.js handles most cleanup automatically
  },
});
